import { CurrencyCode } from '../common';

export type MoneyFilter = (amount: number, options?: MoneyFilterOptions) => string;

/**
 * Number - display currency purely as a number with no symbol or code
 * symbol - e.g. $1,234.56
 * uniqueSymbol - e.g. $A1,234.56
 * code - e.g. 1,234.56 AUD
 */
export type MoneyFilterFormat = 'code' | 'number' | 'symbol' | 'uniqueSymbol';

export interface MoneyFilterOptions {
    code?: CurrencyCode;
    format?: MoneyFilterFormat;
    fractionSize?: number;
}

export const DEFAULT_FORMAT = 'symbol';
export const DEFAULT_FRACTION_SIZE = 2;
